$(".mentors.mentor_application_review").ready(function () {
	$('#accept_application').click(function () {
		$('#dialog-accept_application').dialog({
			width: "auto",
			modal: true,

			buttons: {
				"Confirm": function () {
					$('#accept_mentor_application')[0].click();
				},

				Cancel: function () {
					$(this).dialog("close");
				}
			}
		});
	});

	$('#reject_application').click(function () {
		$('#dialog-reject_application').dialog({
			width: "auto",
			modal: true,

			buttons: {
				"Send": function () {
					if ($('#reject_reason').val().length > 0) {
						$('#reject_mentor_application')[0].click();
					} else {
						$('#dialog-reject_application #error_message').fadeIn();
					}
				},

				Cancel: function () {
					$(this).dialog("close");
				}
			}
		});
	});
});